export default __webpack_public_path__ + "static/media/CT_Persona1.e1b72160.png";